module.exports = __webpack_public_path__ + "img/noodzly-logo.59261db1.png";